import React from 'react'

const WorkspaceContext = React.createContext({})
const GlobalContext = React.createContext({})

export { WorkspaceContext, GlobalContext }
